module.exports = __webpack_public_path__ + "static/img/2-5.7c96faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-5.png
// module id = W5tG
// module chunks = 1